/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import { themeColors } from 'utils/theme';
// styles
import injectSheet from 'react-jss'
import styles from './colorpalette_styles'


/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: SITE THEME SECTION : COLORS - COLOR PALETTE ~~~~~~~~~~ ========== */
const ColorPalette = injectSheet(styles)(({ classes, text, name }) => {

  return (
    <div className={`colorpalette ${classes.colorpalette}`}>
      {text && <span className='name'>{text}</span>}
      <span className='colorpalettewrap'>
        { themeColors && themeColors[name].map(color => (
          <span className='color' style={{ background: color }}></span>
        ))}
      </span>
    </div>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ColorPalette